// SEO VIDEO SCHEMA
export const setVideoSchema = ({ embedUrl, uploadDate, duration, thumbnailUrl, dataVideoId, name, description, }) => {
    const videoSchema = {
        '@context': 'https://schema.org',
        '@type': 'VideoObject',
        name,
        description,
        duration,
        embedUrl,
        thumbnailUrl,
        uploadDate,
    };
    let script = document.querySelector('.video-structured-data');
    if (script) {
        script.textContent = JSON.stringify(videoSchema);
        document.body.append(script);
    }
    else {
        script = document.createElement('script');
        script.setAttribute('type', 'application/ld+json');
        script.setAttribute('class', 'video-structured-data');
        script.setAttribute('data-video-id', dataVideoId);
        script.textContent = JSON.stringify(videoSchema);
        document.body.append(script);
    }
};
//# sourceMappingURL=setVideoSchema.js.map